var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsDown = function SvgThumbsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.625 2.438h2.438v5.28H1.624a.406.406 0 0 1-.406-.405v-4.47a.406.406 0 0 1 .406-.405"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.063 7.719 2.03 4.062a1.625 1.625 0 0 0 1.626-1.625V8.937h3.143a.808.808 0 0 0 .803-.914l-.61-4.875a.81.81 0 0 0-.802-.71h-6.19"
  })));
};
export default SvgThumbsDown;